// "On the platform now": clients online this minute — what they're looking at, their order in
// progress (and how close it is to a better discount), how long they've been on, and their rep.
// "Worth a call now" marks someone with an order building for a while or near the next tier.
// Used on the staff dashboard (everyone) and the rep home (their own clients).
import { Link } from 'react-router-dom';
import { fmtMoney } from '../lib/matrix.js';

const onFor = (m) => (m == null ? null : m < 1 ? 'just arrived' : m < 60 ? `on for ${m} min` : `on for ${Math.floor(m / 60)} h ${m % 60} min`);

export default function LiveClients({ users, title = 'On the platform now', showRep = true, empty = 'No clients online right now.' }) {
  return (
    <section aria-label={title} className="rounded-2xl border border-line bg-surface p-4 shadow-sm">
      <h2 className="flex items-center gap-2 text-[15px] font-bold text-text-primary">
        <span className={`h-2 w-2 rounded-full ${users?.length ? 'bg-success ring-4 ring-success-light' : 'bg-line-strong'}`} />
        {title} · {users?.length ?? '…'}
      </h2>
      {users?.length === 0 && <p className="mt-2 text-sm text-text-muted">{empty}</p>}
      <ul className="mt-1">
        {(users || []).map((u) => (
          <li key={u.id} className="border-b border-surface-raised py-2.5 last:border-0">
            <div className="flex items-start justify-between gap-2">
              <div className="min-w-0 text-[13px]">
                <div className="flex flex-wrap items-center gap-1.5">
                  <span className="font-semibold text-text-primary">{u.company || 'Client'}</span>
                  {u.hot && <span className="rounded-full bg-orange-50 px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide text-orange-700">Worth a call now</span>}
                </div>
                <div className="text-xs text-text-muted">
                  {u.name}
                  {onFor(u.onForMin) ? ` · ${onFor(u.onForMin)}` : ''}
                  {showRep && u.rep ? ` · ${u.rep}` : ''}
                </div>
              </div>
              {u.companyId && (
                <Link to={`/clients/${u.companyId}`} className="shrink-0 text-xs font-semibold text-text-primary hover:underline">
                  Open
                </Link>
              )}
            </div>
            {u.page && <div className="mt-1 text-xs text-text-secondary">{u.page}</div>}
            {u.cart && (
              <div className="mt-1 text-xs">
                <span className="font-semibold text-text-primary">Order in progress: {fmtMoney(u.cart.subtotal, u.cart.currency)}</span>
                <span className="text-text-muted"> · {u.cart.units} unit{u.cart.units === 1 ? '' : 's'}</span>
                {u.tier && (
                  <span className="block font-semibold text-orange-700">
                    {fmtMoney(u.tier.gap, u.tier.currency)} from {u.tier.percent}% off ({u.tier.name})
                  </span>
                )}
              </div>
            )}
          </li>
        ))}
      </ul>
    </section>
  );
}
